export default {
  articletype: 'Type d\'articles',
  articletypes: 'Types d\'articles',
  verbose_articletype: 'un type d\'articles',
  select_articletype: 'Sélectionner un type d\'article',
  messages: {
    articletype_not_found: 'Type d\'articles non trouvé',
  },
};
